import { GET_ALL_LANGUAGES, GET_SINGLE_LANGUAGE_DATA } from "./actionTypes";

import Axios from "axios";
import {
  GET_ALL_LANGUAGES_URL,
  GET_SINGLE_LANGUAGE_DATA_URL,
} from "../../configs";

export const getAllLanguages = () => (dispatch) => {
  return Axios.post(GET_ALL_LANGUAGES_URL)
    .then((response) => {
      const languages = response.data;
      return dispatch({ type: GET_ALL_LANGUAGES, payload: languages });
    })
    .catch(function(error) {
    });
};

export const getSingleLanguageData = (id) => (dispatch) => {
  return Axios.post(GET_SINGLE_LANGUAGE_DATA_URL, {
    id: id,
  })
    .then((response) => {
      
      const language = response.data;

      // Store language data in localStorage
      if (Array.isArray(language) && language.length > 0) {
        language.forEach((item, index) => {
          if (item.key && item.value !== null && item.value !== undefined) {
            localStorage.setItem(item.key, item.value);
          } else {
          }
        });
      } else if (language && typeof language === 'object' && !Array.isArray(language)) {
        // Handle case where response is an object instead of array
        Object.keys(language).forEach(key => {
          if (language[key] !== null && language[key] !== undefined) {
            localStorage.setItem(key, language[key]);
          }
        });
      } else {
      }

      return dispatch({ type: GET_SINGLE_LANGUAGE_DATA, payload: language });
    })
    .catch(function(error) {
    });
};
